// @flow
/* eslint sort-keys: "error"*/

import type {SystemData} from '../../server/utils/systemData';

export type State = SystemData;
export type SiteFeatures = $PropertyType<SystemData, 'siteFeatures'>;

const initialState = {
    badBotPageSize: 10,
    brand: 'homeaway_us',
    brandId: '',
    cookie: '',
    currency: 'USD',
    directEntry: false,
    domainName: '',
    environment: 'development',
    facebook: {admins: '', appId: '', locale: 'en_US_HA'},
    fullLocale: 'en_US_HA',
    gtsQuery: false,
    hasSortLegalDisclaimer: false,
    havId: '',
    hostname: '',
    isBadBot: false,
    isDesktop: false,
    isGoodBot: false,
    isInternalUser: false,
    isMetric: false,
    isMobile: false,
    isTablet: false,
    locale: 'en-US',
    mockResponse: '',
    referer: '',
    searchFilterCounts: true,
    siteFeatures: {
        hasMetricAreaUnit: false,
        hasSortLegalDisclaimer: false,
        showTotal: false
    },
    siteName: 'homeaway_us',
    theme: 'gt',
    transitionBanner: ''
};

const identity = (state: State = initialState) => state;

export default identity;
